<div class="group-licenses">
  <lms-licenses-list
    #groupLicensesList
    [listId]="groupLicenseslistId"
    [selectable]="true"
    [options]="{ filters: filters, aggregates: 'currentSublicenseId', populate: 'user' }"
    (onSelectedLicenses)="onSelectedLicenses($event)"
  >
    <!-- inject toolbar actions -->
    <ng-content select="[tools-actions]" licenses-actions></ng-content>
    <!-- inject bulk actions -->
    <ng-container licenses-bulk-actions *ngTemplateOutlet="licensesBulkActions"></ng-container>
  </lms-licenses-list>
</div>

<!-- template for licenses list bulk actions -->
<ng-template #licensesBulkActions>
  <div class="actions">
    <ng-container *ngIf="canLicensesBeExtended">
      <div *lmsProfileGuard="'licenses.extend'" tools-actions>
        <a (click)="licensesEndDateExtend.openCalendar()" title="{{ 'actions.extend' | translate }}">
          {{ 'actions.extend' | translate }}
        </a>
        <lms-extend
          #licensesEndDateExtend
          [students]="selection?.total"
          [options]="licensesExtensionOptions"
          (dateSelected)="extendSelectedLicenses($event)"
        ></lms-extend>
      </div>
    </ng-container>
    <div *lmsProfileGuard="'licenses.cancel'" tools-actions>
      <a (click)="openModal(jobs.CANCEL_LICENSES_BULK)" title="{{ 'actions.cancelInscription' | translate }}">
        {{ 'actions.cancelInscription' | translate }}
      </a>
    </div>
    <div tools-actions>
      <lms-button-actions [items]="bulkActions" (change)="selectAction($event)"></lms-button-actions>
      <lms-personalized-email
        #personalizedEmail
        [adminData]="user"
        [count]="selection?.total"
        (sendEmail)="sendEmail($event)"
      ></lms-personalized-email>
      <lms-change-group-modal
        #changeGroupModal
        [group]="group"
        [total]="selection?.total"
        (onSelectGroup)="changeGroupLicenses($event)"
      ></lms-change-group-modal>
    </div>
  </div>
</ng-template>

<!-- bulk actions confirmation modal -->
<lms-modal #activateModal size="small">
  <div class="gl-popup__title">{{ 'licenses.bulk.' + action.toLowerCase() + 'Title' | translate }}</div>
  <div class="gl-popup__close" (click)="activateModal.close()">
    <span class="glicon-close"></span>
  </div>
  <div
    class="gl-popup__text"
    [innerHtml]="
      'licenses.bulk.' + action.toLowerCase() + (selection?.total > 1 ? 'Text' : 'TextSingle')
        | translate
          : {
              total: selection?.total,
              groupName: group.name
            }
    "
  ></div>
  <div class="gl-popup__buttons">
    <gl-button color-secondary [text]="'actions.cancel' | translate" (onClick)="activateModal.close()"></gl-button>
    <gl-button color-primary [text]="'actions.confirm' | translate" (onClick)="confirmModal()"></gl-button>
  </div>
</lms-modal>
